import { certificateTemplateList } from "constants/certificate";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const getCertificateTemplateList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_certificate_template_list(pageNum, filters);
    dispatch({ type: certificateTemplateList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: certificateTemplateList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const addCertificateTemplate = async (bodyData) => {
  try {
    const res = await api.add_certificate_template(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getCertificateTemplateById = async (id) => {
  try {
    const res = await api.get_certificate_template_by_id(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const editCertificateTemplate = async (id, bodyData) => {
  try {
    const res = await api.edit_certificate_template(id, bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const deleteCertificateTemplate = async (id) => {
  try {
    const res = await api.delete_certificate_template(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const saveTraineeCertificateImage = async (certificateID, bodyData) => {
  try {
    const res = await api.save_trainee_certificate_image(certificateID, bodyData)
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
}